/**
 * @generated SignedSource<<a7929ed8faf1eaa7247c7d0c6b2ce94d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type footerRenderer_nativeIssueTable_rankField$data = {
  readonly " $fragmentSpreads": FragmentRefs<"issueCreateFooter_nativeIssueTable_rankField">;
  readonly " $fragmentType": "footerRenderer_nativeIssueTable_rankField";
};
export type footerRenderer_nativeIssueTable_rankField$key = {
  readonly " $data"?: footerRenderer_nativeIssueTable_rankField$data;
  readonly " $fragmentSpreads": FragmentRefs<"footerRenderer_nativeIssueTable_rankField">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "footerRenderer_nativeIssueTable_rankField",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "issueCreateFooter_nativeIssueTable_rankField"
    }
  ],
  "type": "JiraJqlFieldWithAliases"
};

(node as any).hash = "51e407fb70a032eedb7750b35ea0492c";

export default node;
